export const getStringWithQueryParameters = (
  url: string,
  parameters: Record<string, null | number | string | undefined>
) => {
  try {
    const urlObject = new URL(url);

    for (const key of Object.keys(parameters)) {
      const value = parameters[key];
      if (value !== null && value !== undefined && value !== '') {
        urlObject.searchParams.append(key, value.toString());
      }
    }

    return urlObject.toString();
  } catch {
    return url;
  }
};
